import { ITreeStructure } from '../models/treeStructure'

export const getAllAncestorsForItem = (item: ITreeStructure): ITreeStructure[] => {
  if (!item.parent) {
    return []
  }

  return [...getAllAncestorsForItem(item.parent), item.parent]
}
